<template>
  <div
    class="statuscourse"
    :class="[free == true ? 'free' : '', top == true ? 'popular' : '']"
  >
    <p v-if="top == true" >+ Vendido</p>
    <p v-if="free == true" class="text-center">Gratis</p>
  </div>
</template>

<script>
export default {
  props: {
    free: {
      default: null,
    },
    top: {
      default: null,
    },
  },
};
</script>
